import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { PortfolioHoldingResponse } from 'src/app/models/portfolio-models/portfolio-holding-response.model'

import { ProfileData } from '../../../portfolio.model'

@Component({
  selector: 'holding-details-results',
  templateUrl: './holding-details-results.component.html',
  styleUrls: ['./holding-details-results.component.scss'],
})
export class HoldingDetailsResultsComponent
  implements OnChanges, AfterViewInit {
  @Input() holdingsData: PortfolioHoldingResponse
  @Input() currentType: string
  @Input() profileData: ProfileData
  @Input() pcfAcceptedFlag: boolean

  @ViewChild('holdingsTable') divTable: ElementRef

  isScrollableForWindowSize: boolean
  scrollBarPosition = 0
  showRightButton = true

  showRegularHoldings: boolean
  showMoneyMarketHoldings: boolean
  showPcfHoldings: boolean
  leftHtmlId: string
  selectionChanged: any
  pcfWasSet: boolean
  scrollWidth: number
  offsetWidth: number

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.currentType) {
      this.selectionChanged = changes?.currentType?.currentValue
      this.currentType = changes?.currentType?.currentValue
    }
    this.determineTable()
    this.setWidths()
  }

  ngAfterViewInit(): void {
    this.setWidths()
  }

  setWidths() {
    if (
      this.divTable?.nativeElement?.scrollWidth > 0 &&
      this.divTable?.nativeElement?.offsetWidth > 0
    ) {
      this.scrollWidth = this.divTable?.nativeElement?.scrollWidth
      this.offsetWidth = this.divTable?.nativeElement?.offsetWidth
    }
  }
  // eslint-disable-next-line complexity, max-statements
  determineTable() {
    this.showPcfHoldings =
      this.currentType === 'pcf-holdings' &&
      this.holdingsData?.size > 0 &&
      this.pcfAcceptedFlag

    this.showRegularHoldings =
      this.holdingsData?.fund?.entity &&
      JSON.stringify(this.holdingsData?.fund?.entity[0]) !== '{}' &&
      !this.profileData?.isMoneyMarket &&
      this.currentType !== 'pcf-holdings' &&
      this.profileData?.fundId !== '0517'

    this.showMoneyMarketHoldings =
      this.profileData?.isMoneyMarket &&
      (this.currentType === 'short-term reserve' ||
        this.currentType === 'money-market-range')

    switch (true) {
      case !this.profileData?.isMoneyMarket: {
        let thHolder = 'th-placeholder'
        if (this.currentType === 'derivative') {
          thHolder = thHolder.concat('-derivative')
        }
        this.leftHtmlId = thHolder
        break
      }
      case this.showMoneyMarketHoldings: {
        this.leftHtmlId = 'th-placeholder-mm'
        break
      }
    }
  }

  setScrollable(isScrollable: boolean) {
    this.isScrollableForWindowSize = isScrollable
  }

  isNumber(number: any): boolean {
    return !isNaN(Number(number))
  }
}
